import {Link} from "react-router-dom";

import {styled} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import LoadingButton from '@mui/lab/LoadingButton';

import {anchor} from "../../themes/style";
import Typography from "@mui/material/Typography";
import {toRem} from "../../themes/utils";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import EmailIcon from "@mui/icons-material/Email";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import {DataGrid} from "@mui/x-data-grid";

export const StyledLink = styled(Link)({
    textDecoration: "none",
    ...anchor
})

export const StyledAccordion = styled(Accordion)({
    "&.MuiAccordion-root": {
        maxWidth: "450px"
    }
})

export const StyledHeaderButton = styled(LoadingButton)<{ backgroundcolor?: string, isloading?: string, startIcon?:any }>((props) => ({
    "&.MuiButton-root": {
        backgroundColor: props.backgroundcolor,
        color: props.isloading === "true" ? props.backgroundcolor : "#000",
        boxShadow: "none",
        marginBottom: "5px",
    }
}))

export const StyledContentSubtitle = styled(Typography)({
    marginBottom: toRem(24),
})

export const StyledPhoneEnabledIcon = styled(PhoneEnabledIcon)(({theme}) =>({
    color: theme.palette.primary.main,
    fontSize: toRem(20),
    marginRight: toRem(8)
}))

export const StyledEmailIcon = styled(EmailIcon)( ({theme}) => ({
    color: theme.palette.primary.main,
    fontSize: toRem(20),
    marginRight: toRem(8)
}))

export const StyledPhoneAndroidIcon = styled(PhoneAndroidIcon)( ({theme}) => ({
    color: theme.palette.primary.main,
    fontSize: toRem(20),
    marginRight: toRem(8)
}))

export const StyledDataGrid = styled(DataGrid)({
    '& .MuiDataGrid-columnSeparator': {
        display: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
        borderTop: "1px solid rgba(224, 224, 224, 1)",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
    }
})